import { render } from "./SpecificationOrder.vue?vue&type=template&id=1ba33cbe&scoped=true"
import script from "./SpecificationOrder.vue?vue&type=script&lang=js"
export * from "./SpecificationOrder.vue?vue&type=script&lang=js"

import "./SpecificationOrder.vue?vue&type=style&index=0&id=1ba33cbe&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba33cbe"]])

export default __exports__